import { Component, Input, ChangeDetectorRef, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FikoCycleTimeRaporComponent } from '../fiko-cycle-time-rapor/fiko-cycle-time-rapor.component';

@Component({
  selector: 'fiko-sim-motor-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './fiko-sim-motor-dialog.component.html',
  styleUrls: ['./fiko-sim-motor-dialog.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FikoSimMotorDialogComponent implements OnDestroy {

  /** FikoDialogCore pencere referansi */
  private _pencere: any;
  @Input() set pencere(v: any) {
    this._pencere = v?.instance || v;
  }
  get pencere(): any { return this._pencere; }

  /** Similasyon component referansi - canli veri icin */
  private _sim: any;
  @Input() set simComponent(v: any) {
    this._sim = v;
    // Periyodik guncelleme baslat
    this.guncellemeyiBaslat();
  }
  get sim(): any { return this._sim; }

  private guncelleTimer: any;

  constructor(public CD: ChangeDetectorRef) {}

  private guncellemeyiBaslat() {
    this.guncellemeyiDurdur();
    // 200ms aralıkla sim component'ten güncel değerleri al
    this.guncelleTimer = setInterval(() => {
      this.CD.detectChanges();
    }, 200);
  }

  private guncellemeyiDurdur() {
    if (this.guncelleTimer) {
      clearInterval(this.guncelleTimer);
      this.guncelleTimer = null;
    }
  }

  // === Motor Seçimi ===
  kutukMotorDegistir(mod: string) {
    this.sim?.kutukMotorDegistir(mod);
    this.CD.detectChanges();
  }

  // === Motor Ayarları ===
  motorAyarlariUygula() {
    this.sim?.motorAyarlariUygula();
    this.CD.detectChanges();
  }

  // === CNC Kesim Modu ===
  silindirYonModuDegisti(mod: number) {
    this.sim?.silindirYonModuDegisti(mod);
    this.CD.detectChanges();
  }

  tiklandiTersYonToggle() {
    this.sim?.tiklandiTersYonToggle();
    this.CD.detectChanges();
  }

  // === Sarma ===
  snapshotlariTemizle() {
    this.sim?.snapshotlariTemizle();
    this.CD.detectChanges();
  }

  // === Stok Ayarları ===
  stokRenkDegisti(renk: string) {
    this.sim?.stokRenkDegisti(renk);
    this.CD.detectChanges();
  }

  tiklandiKalitePreseti(preset: string) {
    this.sim?.tiklandiKalitePreseti(preset);
    this.CD.detectChanges();
  }

  tiklandiMalzemePreset(preset: string) {
    this.sim?.tiklandiMalzemePreset(preset);
    this.CD.detectChanges();
  }

  tiklandiRenklendirmeModuDegistir() {
    this.sim?.tiklandiRenklendirmeModuDegistir();
    this.CD.detectChanges();
  }

  manuelPBRDegisti() {
    this.sim?.manuelPBRDegisti();
    this.CD.detectChanges();
  }

  aoYogunlukDegisti() {
    this.sim?.aoYogunlukDegisti();
    this.CD.detectChanges();
  }

  aoRadiusDegisti() {
    this.sim?.aoRadiusDegisti();
    this.CD.detectChanges();
  }

  dexelSmoothingDegisti() {
    this.sim?.dexelSmoothingDegisti();
    this.CD.detectChanges();
  }

  toneMappingExposureDegisti() {
    this.sim?.toneMappingExposureDegisti();
    this.CD.detectChanges();
  }

  tiklandiKenarCizgileriToggle() {
    this.sim?.tiklandiKenarCizgileriToggle();
    this.CD.detectChanges();
  }

  tiklandiIcDuvarToggle() {
    this.sim?.tiklandiIcDuvarToggle();
    this.CD.detectChanges();
  }

  kenarOpaklikDegisti() {
    this.sim?.kenarOpaklikDegisti();
    this.CD.detectChanges();
  }

  kenarEsikDegisti() {
    this.sim?.kenarEsikDegisti();
    this.CD.detectChanges();
  }

  // === Araçlar: Görünüm ===
  ciz() {
    this.sim?.ciz();
  }

  tiklandiTutucuTanimla() {
    this.sim?.tiklandiTutucuTanimla();
    this.CD.detectChanges();
  }

  // === Araçlar: Kamera ===
  tiklandiKameraKilitle() {
    this.sim?.tiklandiKameraKilitle();
    this.CD.detectChanges();
  }

  pozisyonDegisti() {
    this.sim?.pozisyonDegisti();
    this.CD.detectChanges();
  }

  tiklandiHudToggle() {
    this.sim?.tiklandiHudToggle();
    this.CD.detectChanges();
  }

  // === Araçlar: Director ===
  directorModeAc() {
    this.sim?.directorModeAc();
  }

  // === Araçlar: Efektler ===
  tiklandiSesToggle() {
    this.sim?.tiklandiSesToggle();
    this.CD.detectChanges();
  }

  tiklandiEfektToggle() {
    this.sim?.tiklandiEfektToggle();
    this.CD.detectChanges();
  }

  tiklandiSonarToggle() {
    this.sim?.tiklandiSonarToggle();
    this.CD.detectChanges();
  }

  // === Araçlar: Analiz ===
  tiklandiCarpismaToggle() {
    this.sim?.tiklandiCarpismaToggle();
    this.CD.detectChanges();
  }

  tumCarpismalariTara() {
    this.sim?.tumCarpismalariTara();
    this.CD.detectChanges();
  }

  taramaIptalEt() {
    this.sim?.taramaIptalEt();
    this.CD.detectChanges();
  }

  tiklandiCarpismaNoktasi(nokta: any) {
    this.sim?.tiklandiCarpismaNoktasi(nokta);
    this.CD.detectChanges();
  }

  cycleTimeAnaliziHesapla() {
    this.sim?.cycleTimeAnaliziHesapla();
    this.CD.detectChanges();
  }

  tiklandiCizgiModuToggle() {
    this.sim?.tiklandiCizgiModuToggle();
    this.CD.detectChanges();
  }

  ngOnDestroy() {
    this.guncellemeyiDurdur();
  }
}
